import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class LanguageService extends BaseService{
	constructor() {
		super('/Language');
	}

	public getAllByFilter(filter: LanguageFilter) {
		return super.getAllByFilterBase(filter);
	}

}

export class LanguageFilter extends BaseFilter {
	constructor(IsEnabled?: boolean | null) {
		super();
		this._IsEnabled = IsEnabled;
	}

	private _IsEnabled?: boolean | null;
	

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._IsEnabled != null ? { IsEnabled: this._IsEnabled } : {})
		);

		return data;
	};
}